import React from "react";
import { Row, Col } from "antd";
import { SelectItem } from "../../../components/forms/FormItems";
import { useClientCategories } from "../../../hooks";
import { InputItem } from "../../../components/forms/FormItems";
import ImageFormItem from "../../../components/forms/ImageFormItem";
import { RestrictedSettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import FormHeader from "../../../components/forms/FormHeader";

const GeneralDetails = () => {
  const clientCategories = useClientCategories();
  const category = clientCategories?.find((c) => c.revaha);
  const serviceTypes = category
    ? category?.service_types?.map((i) => {
        return {
          name: i.name,
          value: i.id,
        };
      })
    : [];

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.organization.generalDetails" />}
        />

        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={8}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  required={true}
                  name="name"
                  category="organization"
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <RestrictedSettingsDataSelect
                  name="type_id"
                  category="organization"
                  settingsdataName={"system_tables/company_types"}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="tax_id"
                  required={true}
                  category="organization"
                  onlyDigits={true}
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="foreign_worker_association_id"
                  category="organization"
                  onlyDigits={true}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="service_provider_number"
                  required={true}
                  category="organization"
                  onlyDigits={true}
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="supporting_community_service_provider_number"
                  category="organization"
                  onlyDigits={true}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="revaha_service_provider_number"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                {clientCategories && (
                  <SelectItem
                    data={serviceTypes}
                    mode={"multiple"}
                    name="ok2go_revaha_service_types"
                    category="organization"
                  />
                )}
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="vat_account_number"
                  category="organization"
                  onlyDigits={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="income_tax_deduction_protfolio"
                  category="organization"
                  onlyDigits={true}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="masav_code_subject"
                  category="organization"
                  number={true}
                  eightPositiveNumbers={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="masav_code_sender"
                  category="organization"
                  fivePositiveNumbers={true}
                  number={true}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>

          <Col
            xs={24}
            sm={24}
            md={24}
            lg={12}
            xl={{ span: 6, offset: 2 }}
            xxl={{ span: 4, offset: 2 }}
          >
            <ImageFormItem name="avatar_url" />
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default GeneralDetails;
